import * as React from 'react';

import './styles.scss';
import classNames from 'classnames';

import ControlCheckbox from '../ControlCheckbox';

export interface ICheckboxWithLabelProps {
    /** Label to display */
    label: string | React.ReactNode;
    /** Description for label */
    description?: React.ReactNode;
    /** State of Checkbox */
    checked: boolean;
    /** Disabled status */
    disabled?: boolean;
    /** Change event */
    onChange: (event) => void;
    /** Error */
    hasError?: boolean;
    /** Checkbox wiggle on error */
    errorAnimated?: boolean;
    /** DOM target element name attribute */
    name?: string;
    /** DOM target element id attribute */
    id?: string;
    /** Indent level to apply */
    indent?: 1 | 2 | 3 | 4;
    /** Additional meta to display */
    meta?: React.ReactNode;
    /** Value */
    value?: string;
    /** Data test id for automated tests */
    testId?: string;
}

interface IState {
}

/**
 * ControlCheckbox extension to display label before Checkbox element.
 */
class CheckboxWithLabel extends React.Component<ICheckboxWithLabelProps, IState> {
    static displayName: string = 'CheckboxWithLabel';

    private nodeCheckbox;

    render () {
        return (
            <React.Fragment>
                <div className={classNames('checkbox-with-label', {
                    'indent-1': this.props.indent === 1,
                    'indent-2': this.props.indent === 2,
                    'indent-3': this.props.indent === 3,
                    'indent-4': this.props.indent === 4,
                })}>
                    <ControlCheckbox
                        checked={this.props.checked}
                        disabled={this.props.disabled}
                        onChange={this.props.onChange}
                        hasError={this.props.hasError}
                        errorAnimated={this.props.errorAnimated}
                        name={this.props.name}
                        id={this.props.id}
                        ref={(node) => this.nodeCheckbox = node}
                        wrapperElement={'span'}
                        value={this.props.value}
                        testId={this.props.testId}
                    />
                    <label
                        htmlFor={this.props.id}
                        className="checkbox-with-label-label-wrapper"
                        onClick={() => {
                            if (this.nodeCheckbox) {
                                this.nodeCheckbox.click();
                            }
                        }}
                    >
                    <span className={classNames('checkbox-with-label-label', {
                        'has-error': this.props.hasError,
                        'error-animated': this.props.errorAnimated,
                    })}>

                        {this.props.label}
                    </span>
                        {!!this.props.description && (
                            <span className="checkbox-with-label-description">{this.props.description}</span>
                        )}
                    </label>
                </div>
                {!!this.props.meta && (
                    <div className="checkbox-with-label-meta">{this.props.meta}</div>
                )}
            </React.Fragment>
        );
    }
}

export default CheckboxWithLabel;
